import { render, staticRenderFns } from "./DsfPptsSetting.vue?vue&type=template&id=73740baa&"
import script from "./DsfPptsSetting.vue?vue&type=script&lang=js&"
export * from "./DsfPptsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/control/DsfPptsSetting.vue"
export default component.exports